export default __webpack_public_path__ + "static/media/037-target.aa92dc5c.png";